import { useMemo, useState } from 'react';

import { useToggle } from '@repo/react-hooks/useToggle';

import { SelectWorkspaceUpgrade } from './SelectWorkspaceUpgrade';

export const useSelectWorkspaceUpgrade = () => {
  const { value: isDialogOpen, setValue } = useToggle();
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState<string | null>(
    null
  );

  return useMemo(
    () => ({
      dialogProps: {
        isOpen: isDialogOpen,
        setIsOpen: setValue,
        selectedWorkspaceId,
        setSelectedWorkspaceId,
      },
      DialogComponent: SelectWorkspaceUpgrade,
      openDialog: () => {
        setValue(true);
      },
      closeDialog: () => {
        setValue(false);
      },
    }),
    [isDialogOpen, setValue, selectedWorkspaceId]
  );
};
